import { Table } from '@radix-ui/themes';
import { renderNumber } from 'components/common/training-data-table/common';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { TrajHelper } from 'lib_ts/classes/trajectory.helper';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import {
  IBallState,
  ITrajectory,
  ITrajektRefBreak,
} from 'lib_ts/interfaces/pitches';
import { useContext } from 'react';

export const DataTableTargetRow = (props: {
  priority: BuildPriority;
  targetBS: IBallState;
  targetBreaks?: ITrajektRefBreak;
  targetTraj: ITrajectory;
}) => {
  const { unitFactors } = useContext(MachineContext);

  const speedMph = TrajHelper.getSpeedFromTraj(props.targetTraj);

  switch (props.priority) {
    case BuildPriority.Breaks: {
      return (
        <Table.Row>
          <Table.Cell>{t('common.target')}</Table.Cell>

          <Table.Cell>{/* video playback placeholder */}</Table.Cell>

          <Table.Cell align="right">
            {renderNumber(speedMph * unitFactors.fromSpeedMph, 1)}
          </Table.Cell>

          <Table.Cell align="right">
            {renderNumber(
              props.targetBreaks
                ? props.targetBreaks.zInches * unitFactors.fromBreaksIn
                : undefined,
              1
            )}
          </Table.Cell>
          <Table.Cell align="right">
            {renderNumber(
              props.targetBreaks
                ? -1 * props.targetBreaks.xInches * unitFactors.fromBreaksIn
                : undefined,
              1
            )}
          </Table.Cell>

          <Table.Cell>{/* actions placeholder */}</Table.Cell>
        </Table.Row>
      );
    }

    case BuildPriority.Default:
    case BuildPriority.Spins:
    default: {
      return (
        <Table.Row>
          <Table.Cell>{t('common.target')}</Table.Cell>

          <Table.Cell>{/* video playback placeholder */}</Table.Cell>

          <Table.Cell align="right">
            {renderNumber(speedMph * unitFactors.fromSpeedMph, 1)}
          </Table.Cell>

          <Table.Cell align="right">
            {renderNumber(props.targetBS.wx, 0)}
          </Table.Cell>
          <Table.Cell align="right">
            {renderNumber(props.targetBS.wy, 0)}
          </Table.Cell>
          <Table.Cell align="right">
            {renderNumber(props.targetBS.wz, 0)}
          </Table.Cell>

          <Table.Cell>{/* actions placeholder */}</Table.Cell>
        </Table.Row>
      );
    }
  }
};
